import React, { useState } from "react";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../components/ui/tabs";
import PrescriptionTable from "../../components/Admin/PrescriptionTable";
import PrescriptionFrequencyLength from "../../components/Admin/PrescriptionFrequencyLength";
import UsersAdmin from "../../components/Admin/auth/UsersAdmin";
import RolesAdmin from "../../components/Admin/auth/RolesAdmin";
import GroupsAdmin from "../../components/Admin/auth/GroupsAdmin";
import SessionsAdmin from "../../components/Admin/auth/SessionsAdmin";

const TABS: { value: string; label: string }[] = [
  { value: "prescription", label: "Prescription" },
  { value: "frequency-length", label: "Prescription Frequency & Length" },
  { value: "users", label: "Users" },
  { value: "roles", label: "Roles" },
  { value: "groups", label: "Groups" },
  { value: "sessions", label: "Sessions" },
];

const AdminPage: React.FC = () => {
  const [tab, setTab] = useState("prescription");

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      {/* Side Tab Panel */}
      <aside className="w-56 border-r bg-muted/40 p-4">
        <Tabs
          value={tab}
          onValueChange={setTab}
          orientation="vertical"
          className="w-full"
        >
          <TabsList className="flex flex-col gap-2 w-full">
            {TABS.map((t) => (
              <TabsTrigger
                key={t.value}
                value={t.value}
                tabValue={tab}
                onValueChange={setTab}
                className="w-full"
              >
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </aside>
      {/* Main Content */}
      <main className="flex-1 p-6">
        <Tabs
          value={tab}
          onValueChange={setTab}
          orientation="vertical"
          className="w-full"
        >
          <TabsContent value="prescription" tabValue={tab}>
            <PrescriptionTable />
          </TabsContent>
          <TabsContent value="frequency-length" tabValue={tab}>
            <PrescriptionFrequencyLength />
          </TabsContent>
          <TabsContent value="users" tabValue={tab}>
            <UsersAdmin />
          </TabsContent>
          <TabsContent value="roles" tabValue={tab}>
            <RolesAdmin />
          </TabsContent>
          <TabsContent value="groups" tabValue={tab}>
            <GroupsAdmin />
          </TabsContent>
          <TabsContent value="sessions" tabValue={tab}>
            <SessionsAdmin />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminPage;
